import { Routes, Route, useParams } from "react-router-dom"

import './components/ui.css';

import ForecastByStateAreas from "./screens/allAreas"
import ClimbingAreaPage from "./screens/areaDetail";
import HeaderSection from "./components/header";
import FooterSection from "./components/footer";
import HomeScreen from "./screens/home";
import NotFoundPage from "./screens/notFound";
import { RatingsExplainerProvider } from "./components/ratingsExplainer";
import { usePageTracking } from "./hooks/usePageTracking";

function App() {
  usePageTracking();

  return (
    <RatingsExplainerProvider>
      <HeaderSection />
      <Routes>
        {/* Area detail. Also matches the short /area/:areaId form and older
            /area/:areaId/hourly|averages/... links; the page swaps in the canonical URL */}
        <Route path="/area/:areaId/*" element={<AreaDetail />} />

        {/* Browser Areas */}
        <Route path="/forecast-by-state/:stateCode?" element={<ForecastByState />} />

        {/* Home Page */}
        <Route path="/" element={<HomeScreen />} />

        {/* Anything else */}
        <Route path="*" element={<NotFoundPage />} />

      </Routes>
      <FooterSection />
    </RatingsExplainerProvider>
  );
}

function ForecastByState() {
  const { stateCode } = useParams();
  return <ForecastByStateAreas code={stateCode} />
}

function AreaDetail() {
  const { areaId } = useParams();
  return <ClimbingAreaPage areaId={areaId || ''} />;
}

export default App;
